import { ChangeDetectionStrategy, Component, inject, input, model, OnInit } from '@angular/core'
import { TbTab } from '@components-library/tb-tab/tb-tab.component'
import { TbAccordionComponent } from '@components-library/tb-accordion/tb-accordion.component'
import { TbIconComponent } from '@components-library/tb-icon/tb-icon.component'
import { TranslocoDirective } from '@jsverse/transloco'
import { ViewSectionContentComponent } from '@app/feature/header/workspace-controls/advanced-options/view-section/view-section-content/view-section-content.component'
import { WorkspaceViewRecord } from '@models/ui'
import { ViewTypeWithIcon } from '@app/views/views-list'
import { map, reduce } from 'lodash-es'
import { ModalManagerService } from '@components-library/tb-modal-manager/modal-manager.service'
import {
    SelectViewsSettingsComponent,
    ViewConfigurationData,
} from '@app/feature/header/workspace-controls/advanced-options/view-section/select-views-settings/select-views-settings.component'
import { ViewService } from '@services/entity-services/view/view.service'

export interface ViewUI extends ViewTypeWithIcon {
    active: boolean
}

export type ViewsTypeUI = Record<string, ViewUI[]>

@Component({
    selector: 'app-view-section',
    imports: [
        TbAccordionComponent,
        TbIconComponent,
        TranslocoDirective,
        ViewSectionContentComponent,
    ],
    templateUrl: './view-section.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewSectionComponent implements OnInit {
    private readonly modalManagerService = inject(ModalManagerService)
    private readonly viewService = inject(ViewService)
    readonly schemaTabs = input.required<TbTab[]>()
    readonly templateViews = model.required<WorkspaceViewRecord>()

    protected templateViewsTypeUI!: ViewsTypeUI

    ngOnInit() {
        this.templateViewsTypeUI = this.viewsToViewsTypeUI()
    }

    protected openViewConfiguration() {
        this.modalManagerService
            .openDialog<SelectViewsSettingsComponent, ViewConfigurationData, WorkspaceViewRecord>({
                component: SelectViewsSettingsComponent,
                data: {
                    schemas: this.schemaTabs(),
                    views: this.templateViewsTypeUI,
                },
            })
            .subscribe((data) => {
                if (data) {
                    this.templateViews.set(data)
                    this.templateViewsTypeUI = this.viewsToViewsTypeUI()
                }
            })
    }

    private viewsToViewsTypeUI(): ViewsTypeUI {
        return reduce(
            this.templateViews(),
            (viewsRecord, views, key) => {
                viewsRecord[key] = this.getViewUIArray(views)
                return viewsRecord
            },
            {} as ViewsTypeUI,
        )
    }

    private getViewUIArray(views: { [key: string]: boolean }): ViewUI[] {
        return map(views, (active, key) => {
            return {
                name: key,
                icon: this.viewService.getViewIconByCode(key),
                active,
            }
        })
    }
}
